import { connect } from 'react-redux';
import { stateCurrentName } from '@Selectors/StateCurrentSelectors';
import { userHasRegistration } from '@Containers/Header/HeaderComponentSelectors';
import {
  getRouterHref as getRouterHrefAction,
  goToRouterState as goToRouterStateAction,
  openLogoutDialog as openLogoutDialogAction,
} from '@Containers/Header/HeaderComponentActions';
import PropTypes from 'prop-types';
import { paths } from '@AppRoutes/constants';
import AnonShibbolethLogin from './AnonShibbolethLogin';

function AnonShibbolethLoginContainer(props) {
  const { goToRouterState, openLogoutDialog } = props;

  const userLinkHandler = () => {
    goToRouterState(paths.PRIVATE_REGISTER);
  };

  const onSignOutClick = (...args) => {
    openLogoutDialog(...args);
  };

  return <AnonShibbolethLogin {...props} userLinkHandler={userLinkHandler} onSignOutClick={onSignOutClick} />;
}

AnonShibbolethLoginContainer.propTypes = {
  goToRouterState: PropTypes.func,
  openLogoutDialog: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    stateCurrentName: stateCurrentName(state),
    userHasRegistration: userHasRegistration(state),
  };
}

const mapDispatchToProps = {
  getRouterHref: getRouterHrefAction,
  goToRouterState: goToRouterStateAction,
  openLogoutDialog: openLogoutDialogAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(AnonShibbolethLoginContainer);
